import { retrieveToken } from '../storage';
import { apiError, apiFetch, wrapFetchWithDetailedErrors } from './api';

const BASE_URL = process.env.REACT_APP_BACKEND_ENDPOINT;

// The document expiry reminder service of one esercizio (BSS-1869 on the
// server, BSS-1968 here): on/off, one to three preavvisi in days, up to two
// free recipient addresses. The emails themselves leave from a server-side batch
// (BSS-1870); nothing here sends anything.
//
// wrapFetchWithDetailedErrors on purpose: the server's refusals ("I preavvisi
// non possono essere ripetuti.", "I destinatari non possono essere ripetuti.")
// are the sentence the operator has to read.

const url = (esercizioId) =>
  `${BASE_URL}/api/esercizi_commerciali/${encodeURIComponent(
    esercizioId,
  )}/promemoria-scadenze`;

const errore = apiError({ 404: 'Esercizio commerciale non trovato.' });

const headers = (withBody = false) => {
  const result = { Authorization: `Bearer ${retrieveToken()}` };
  if (withBody) {
    result['Content-Type'] = 'application/json';
  }
  return result;
};

/** The configuration, or the system default when the esercizio has none yet. */
export const getPromemoriaScadenze = (esercizioId) =>
  wrapFetchWithDetailedErrors(
    apiFetch(url(esercizioId), { method: 'GET', headers: headers() }),
    errore,
  );

/** Saves the whole configuration, not a patch, and answers what was stored. */
export const salvaPromemoriaScadenze = (esercizioId, configurazione) =>
  wrapFetchWithDetailedErrors(
    apiFetch(url(esercizioId), {
      method: 'PUT',
      headers: headers(true),
      body: JSON.stringify(configurazione),
    }),
    errore,
  );
